import React from 'react';
import { useHistory } from 'react-router-dom';
export const GoBack = () => {
  const history = useHistory();
  return (
    <svg onClick={history.goBack} className="cursor-pointer text-[#0F0F0F]" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.364624 12.8566L11.5657 23.6457C12.0572 24.1181 12.8535 24.1181 13.3462 23.6457C13.8377 23.1733 13.8377 22.4061 13.3462 21.9337L3.03361 12.0006L13.345 2.06752C13.8365 1.59513 13.8365 0.827863 13.345 0.354285C12.8535 -0.118097 12.0559 -0.118097 11.5645 0.354285L0.363382 11.1434C-0.120666 11.6109 -0.120666 12.3903 0.364624 12.8566Z" fill="currentColor"/>
    </svg>    
  );
};
